/**
 * @packageDocumentation
 * @module      EmcJsonToPacketConverter.ts
 * @description Encapsulates the logic to convert Json to EmcPackets.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import EmcPacket from "./EmcPacket";
import EmcPacketProcessor from "./EmcPacketProcessor";
export default class EmcJsonToPacketConverter {
    static processJson(jsonSet) {
        let emcPackets = [];
        jsonSet.forEach(json => {
            let emcPacket = EmcPacket.EmcPacketBuilder.fromJson(json);
            if (null != emcPacket)
                emcPackets.push(emcPacket);
        });
        EmcPacketProcessor.processPacketsJson(emcPackets);
    }
}
//# sourceMappingURL=EmcJsonToPacketConverter.js.map